import { FormControl, Modal, TextField } from '@mui/material';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import MyButton from '../../components/Layout/MyButton';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import TopBar from '../../components/Layout/TopBar';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ClipLoader } from 'react-spinners';
import FormLabel from '@mui/material/FormLabel';
import * as PropTypes from 'prop-types';
import FacturationTable from '../../components/Facturation/FacturationTable';
import { FACTURATION_TYPE, PROFIL, REQUEST_PASS_TYPE } from '../../constants/enum';
import MyComboBox from '../../components/Layout/MyComboBox';
import MyChipSelector from '../../components/Layout/MyChipSelector';
import { logError } from '../../components/Utils/FormatData';
import MySelect from '../../components/Layout/MySelect';

const css = {
  container: { height: '90%', width: '90%', backgroundColor: 'white', borderRadius: '5px', overflow: 'auto' },
  devisContainer: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '90%' },
  fullRow: { height: '100%', width: '100%', alignItems: 'center' },
  row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
  rowSelectedFolder: { overflow: 'visible', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', margin: '20px' },
  rowValidation: { justifyContent: 'flex-end', alignContent: 'flex-end', alignItems: 'center', height: '75px', margin: '10px' },
  formControl: { width: '100%', margin: '0' },
  tableHead: { border: '1px solid #4db4da', backgroundColor: '#0094ca' },
};
function BlobProvider(props) {
  return null;
}
BlobProvider.propTypes = { document: PropTypes.any };

const ModalCreateOrEditFacturation = (props) => {
  const { openModal, setOpenModal, color, facturation_id, setReloadData, dossierId, devisId } = props;
  const requestPassId = new URLSearchParams(location.search).get('id') ? new URLSearchParams(location.search).get('id') : dossierId ? dossierId : null;
  const alert = useAlert();
  const navigate = useNavigate();
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(false);
  const [listeClient, setListeClient] = useState([]);
  const [listeDevis, setListeDevis] = useState([]);
  const [client, setClient] = useState(null);
  const [devis, setDevis] = useState([]);
  const [facture, setFacture] = useState(null);
  const [idSelectedClient, setIdSelectedClient] = useState(null);
  const [idSelectedDevis, setIdSelectedDevis] = useState(null);
  const [etatFacturation, setEtatFacturation] = useState({
    statutDevis: null,
    description: null,
    numDossier: null,
    departement: null,
    refCommande: null,
    sapSent: null,
  });
  const [lines, setLines] = useState([]);
  const [storedLines, setStoredLines] = useState([]);
  const [newline, setNewline] = useState({ newTarif: null });
  const [totalAmount, setTotalAmount] = useState(devis && devis.montant || 0);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    if (openModal) {
      if (profil.profil === 6 || profil.profil === 5) {
        alert.error(`Vous n'êtes pas autorisé à accéder à la création des factures`);
        navigate('/');
      } else {
        document.title = facturation_id ? `TE - Edition d'une facture` : `TE - Création d'une facture`;
        apiListClientAccounts();
        apiListDepartments();
        if (facturation_id) {
          apiGetBillById(facturation_id);
        }
        if (devisId) {
          if (Array.isArray(devisId)) {
            setIdSelectedDevis(devisId[0]);
          } else {
            setIdSelectedDevis(devisId)
          }
        }
        if (dossierId) {
          etatFacturation.numDossier = dossierId;
        }
      }
    }
  }, [openModal]);
  useEffect(() => {
    if (devis) {
      setLines([]);
      getTarifs();
    }
  }, [devis]);
    useEffect(() => {
      if (facture) {
        setLines([]);
        getTarifs();
      }
    }, [facture]);
  useEffect(async () => {
    if (idSelectedDevis) {
      await axios({
        method: 'post',
        url: `${URL_API}/facturation/get-sap-facturations`,
        data: [idSelectedDevis],
      })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            response.data.map((facture) => {
              let tabTarifsFacture = facture.elements_factures.lines;
              let tabTarifsAdditional = facture.elements_factures.additionalLines;
              let firstLine = facture.elements_factures.firstLine;

              let allLines = [];
              if (firstLine && firstLine.tarif > 0) {
                allLines.push(firstLine);
              }
              tabTarifsFacture.forEach((tarifFacture) => {
                allLines.push(tarifFacture);
              });
              tabTarifsAdditional.forEach((tarif) => {
                allLines.push(tarif);
              });

            setStoredLines((prevStoredLines) => [...prevStoredLines, ...allLines]);
            });
          }
        })
        .catch((error) => {
          alert.removeAll();
          alert.error(error.message);
        });

      axios({
        method: 'post',
        url: `${URL_API}/facturation/fact-by-ids`,
        data: [idSelectedDevis],
      })
        .then((response) => {
          setDevis(response.data);
          setEtatFacturation({
            ...etatFacturation,
            departement: response.data[0].dossier.metadata.reference.departments ? response.data[0].dossier.metadata.reference.departments : '',
            refCommande: response.data[0].elements_factures.status.refCommande ? response.data[0].elements_factures.status.refCommande : '',
          })
        })
        .catch((error) => {
          alert.removeAll();
          alert.error(error.message);
        });
    } else {
      setDevis([]);
    }
  }, [idSelectedDevis]);
  useEffect(() => {
    if (idSelectedClient !== null) {
      fetchLoadUser();
    } else {
      setClient(null);
    }
  }, [idSelectedClient]);
  useEffect(() => {
    if (client) {
      getDevis();
    } else {
      setDevis([]);
    }
  }, [client]);
  useEffect(() => {
    if (requestPassId !== null && listeClient.length > 0) {
      apiGetRequestPassById();
    }
  }, [requestPassId, listeClient]);

  const handleCloseModal = () => {
    setIdSelectedDevis(null);
    setStoredLines([]);
    setIsLoading(false);
    setOpenModal(false);
  };
  const handleChangeEtatFacturation = (e) => {
    setEtatFacturation({ ...etatFacturation, [e.target.name]: e.target.value });
  };
  const handleChipSelectorChange = (e) => {
    setIdSelectedDevis(e.target.value);
  };

  const checkIfLineExist = (line) => {
    let exist = false;
    storedLines.forEach((l) => {
      if (l.libelle === line.libelle && l.tarif === line.tarif && l.unite === line.unite && l.description === line.description && l.centre === line.centre) {
        exist = true;
      }
    });

    return exist;
  }

  const saveGrille = () => {
    if (!etatFacturation.departement) {
      alert.error('Le département est requis pour la validation de la facture');
    } else {
      let newlines = [];
      let additionalLines = [];

      lines.forEach((objTarif, i) => {
        if (objTarif.tarif_id) {
          newlines.push({
            quantite: objTarif.quantite,
            libelle: objTarif.libelle,
            tarif: objTarif.tarif,
            unite: objTarif.unite,
            description: objTarif.description,
            centre: objTarif.centre,
            mesures_exploit: objTarif.mesures_exploit,
            code_comptable: objTarif.code_comptable !== '' ? objTarif.code_comptable : profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE ? '60084' : '60081'
          });
        } else {
          additionalLines.push({
            quantite: objTarif.quantite,
            libelle: objTarif.libelle,
            tarif: objTarif.tarif,
            unite: objTarif.unite,
            description: objTarif.description,
            centre: objTarif.centre,
            mesures_exploit: objTarif.mesures_exploit,
            code_comptable: objTarif.code_comptable !== '' ? objTarif.code_comptable : profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE ? '60084' : '60081'
          });
        }
      });

      let elements_factures = {
        devis: [idSelectedDevis],
        status: etatFacturation,
        lines: newlines,
        additionalLines: additionalLines,
        client: facture ? facture.elements_factures.client : devis[0].elements_factures.client
      };

      saveEstimate({
        elements_factures: elements_factures,
        type_facturation: 'facture',
        deleted: false,
        user_id: facture ? facture.user_id : devis[0].user_id,
        dossier_id: facture ? facture.dossier_id : devis[0].dossier_id,
        montant: totalAmount,
      });
    }
  };

  const apiListClientAccounts = () => {
    axios({
      method: 'GET', url: `${URL_API}/utilisateur/liste-client`,
    })
      .then((response) => {
        alert.removeAll();

        let clients = [];
        response.data.forEach((e) => {
          clients.push({ label: e.raison_sociale, key: e.user_id });
        });

        setListeClient(clients);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const saveEstimate = (estimate) => {
    setIsLoading(true);
    axios({ method: 'post', url: `${URL_API}/facturation/save`, data: estimate, params: { userAction: user.user_id, id: facturation_id } })
      .then((response) => {
        setIsLoading(false);
        alert.removeAll();
        alert.success('La facture a bien été enregistrée !');
        setOpenModal(false);

        if (response.data) {
          navigate('/facturation/facture?id=' + response.data);
        } else {
          setReloadData(true);
        }

      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const getDevis = () => {
    axios({ method: 'get', url: `${URL_API}/facturation/full-list-accepted`, params: { type: FACTURATION_TYPE.DEVIS, raison_sociale: client.raison_sociale } })
      .then((response) => {
        let newListeDevis = [];
        response.data.forEach((e) => {
          newListeDevis.push({
            label: `Dossier n°${e.dossier_id} - Devis n°${e.id.toString()}`,
            id: e.id,
          });
        }); // récupération des dossiers validés uniquement

        setListeDevis(newListeDevis);

        getTarifs();
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const apiGetBillById = () => {
    axios({ method: 'get', url: `${URL_API}/facturation/fact-by-id`, params: { id: facturation_id } })
      .then((response) => {
        setFacture(response.data);
        setEtatFacturation(response.data.elements_factures.status);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const fetchLoadUser = () => {
    axios({ method: 'get', url: `${URL_API}/utilisateur/detail-id?id=${idSelectedClient.key}` })
      .then((response) => {
        setClient(response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();

        alert.error(error.response ? error.response.data.message : error);
      });
  };
  const getTarifs = () => {

    // WORKAROUND: j'ai ajouté un setTimeout pour laisser le temps aux lignes de se vider avant d'ajouter les nouvelles, c'est cracra mais ça marche
    setTimeout(() => {
      let tabTarifs = [];

      if (devis.length > 0 && !facturation_id) {
        devis.map((devisEl) => {
          let firstLine = devisEl.elements_factures.firstLine;
          let tabTarifsDevis = devisEl.elements_factures.lines;
          let tabTarifsAdditional = devisEl.elements_factures.additionalLines;
          if (Number(firstLine.tarif) > 0) {
            let exist = checkIfLineExist(firstLine);
            tabTarifs.push({...firstLine, exist: exist});
          }
          tabTarifsDevis.forEach((tarifDevis) => {
            if (Number(tarifDevis.tarif) > 0) {
              let exist = checkIfLineExist(tarifDevis);
              tabTarifs.push({...tarifDevis, exist: exist});
            }
          });
          tabTarifsAdditional.forEach((tarif) => {
            if (Number(tarif.tarif) > 0) {
              let exist = checkIfLineExist(tarif);
              tabTarifs.push({...tarif, exist: exist});
            }
          });
        });
      }

      if (facture) {
        let tabTarifsFacture = facture.elements_factures.lines;
        let tabTarifsAdditional = facture.elements_factures.additionalLines;
        tabTarifsFacture.forEach((tarifFacture) => {
          if (Number(tarifFacture.tarif) > 0) {
            let exist = checkIfLineExist(tarifFacture);
            tabTarifs.push({...tarifFacture, exist: exist});
          }
        });
        tabTarifsAdditional.forEach((tarif) => {
          if (Number(tarif.tarif) > 0) {
            let exist = checkIfLineExist(tarif);
            tabTarifs.push({...tarif, exist: exist});
          }
        });

      }
      setLines(tabTarifs);
    }, 100);
  };
  const apiGetRequestPassById = () => {
    axios({ method: 'get', url: `${URL_API}/demande-passage/recuperer-demande`, params: { id: requestPassId } })
      .then((response) => {
        const requestPassClient = response.data.metadata.complementIdentite.transporteur;
        const findClient = listeClient.find((el) => el.label === requestPassClient);
        if (findClient) setIdSelectedClient(findClient);
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  const apiListDepartments = () => {
    axios({
      method: 'GET',
      url: `${URL_API}/localisation/list-departements`,
    })
      .then((response) => {
        alert.removeAll();
        let departements = [];

        if (response.data && response.data.length > 0) {
          response.data.map((departement) => {
            departements.push(departement.departement);
          });

          setDepartments(departements);
        }

      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };

  return (
    <>
      <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
        <div className='modal'>
          <div style={css.container}>
            <TopBar title={facturation_id ? `Edition de la facture [N°` + facturation_id + `]` : `Création d'une facture`}
                    className='topbar-contenu'
                    color={'#f18d2d'}
                    buttons={
                      <div className='topbar-buttons'>
                        <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#b76618 !important'}} />
                      </div>}
            />

            {/* LOADER */}
            {
              isLoading &&
              <div className='row' style={css.fullRow}>
                <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'} />
              </div>}

            {/* CONTAINER */}
            {
              !isLoading &&
              <div style={css.devisContainer}>
                {!facturation_id && !devisId &&
                  <div className='row' style={{ ...css.rowSelectedFolder, alignContent: 'flex-start', maxHeight: '150px' }}>
                    <FormControl>
                      <FormLabel>Sélectionner un Client</FormLabel>
                      <MyComboBox label={'Client'} options={listeClient} id={'selectedUser'} setter={setIdSelectedClient} value={idSelectedClient ? idSelectedClient : null} />
                    </FormControl>

                    {client &&
                      <FormControl>
                        <FormLabel>Sélectionner un devis</FormLabel>
                          <MySelect labelClass={'select-label-black'}
                            label='Devis'
                            type='text'
                            name='devis'
                            value={idSelectedDevis}
                            datas={listeDevis}
                            multiple={false}
                            autoComplete='off'
                            disableClass={true}
                            style={{ width: '100%' }}
                            displayLabel={true}
                            handleChange={(e) => handleChipSelectorChange(e)}
                        />
                      </FormControl>}
                  </div>
                }
                {(devis.length > 0 || facture) &&
                  <>
                    <div className='row' style={{ height: '75%' }}>
                      <FormControl style={css.formControl}>
                        {lines &&
                          <FacturationTable
                            dossier={devis}
                            listeDossier={listeDevis}
                            lines={lines}
                            setLines={setLines}
                            newLine={newline}
                            setNewLine={setNewline}
                            totalAmount={totalAmount}
                            setTotalAmount={setTotalAmount}
                            isFacture={true}
                          />}
                      </FormControl>
                    </div>

                    <div style={{ height: '20%' }}>
                      <MySelect labelClass={'select-label-black'}
                          label='Départements'
                          type='text'
                          name='departement'
                          value={etatFacturation.departement}
                          datas={departments}
                          multiple={true}
                          autoComplete='off'
                          disableClass={true}
                          style={{ width: '100%' }}
                          displayLabel={true}
                          handleChange={(e) => handleChangeEtatFacturation(e)}
                      />

                      <TextField
                        label='Réf commande client (optionnel)'
                        type='text'
                        name='refCommande'
                        value={etatFacturation.refCommande || ''}
                        style={{ ...css.textField, width: '40%' }}
                        autoComplete='off'
                        onChange={(e) => handleChangeEtatFacturation(e)}
                      />
                    </div>
                    {
                      (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
                      <div className='row' style={css.rowValidation}>
                        <MyButton onClick={() => saveGrille()}
                                  style={'buttonValidation'}
                                  label={'Enregistrer'}
                                  icon={faCheck}
                        />
                        <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} />
                      </div>
                    }
                  </>
                }
              </div>
            }
          </div>
        </div>
      </Modal>
    </>
  );

};

export default ModalCreateOrEditFacturation;
